<template>
  <v-select
    hide-details="auto"
    :items="status"
    v-model="filterDatas.cheqStatus"
    item-text="name"
    item-value="id"
    label="Cheque Status"
    outlined
    clearable
    dense
    @change="emitInput(filterDatas.cheqStatus)"
  ></v-select>
</template>
<script>
import { mapState } from 'vuex';

export default {
  props: {
    clear: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    status: [
      {
        id: 'Pending',
        name: 'Pending',
      },
      {
        id: 'Completed',
        name: 'Completed',
      },
      {
        id: 'Canceled',
        name: 'Cancelled',
      },
      {
        id: 'Return',
        name: 'Return',
      },
    ],
    selectStatus: null,
  }),
  computed: {
    ...mapState(['filterDatas']),
  },
  methods: {
    emitInput(data) {
      this.$store.commit('UPDATE_CHEQUE_STATUS_FILTER', data);

      this.$emit('input', this.filterDatas.cheqStatus);
    },
  },
  watch: {
    clear: {
      handler(val) {
        this.selectStatus = null;
      },
      deep: true,
    },
  },
  created() {
    this.$emit('input', this.filterDatas.cheqStatus);
  },
};
</script>
